import { Permission, User } from "@/script/apps/system/entity/SystemEntity";
import { createStore } from "vuex";
import { LoginUser } from "./LoginUser";
import { TabItem } from "./TabItem";


const globalLoginUser: LoginUser = {
  state: 0,
  token: "",
  user: undefined,
  permissions: []
};

const globaTabItems: TabItem[] = [];

export default createStore({
  state: {
    loginUser: globalLoginUser,
    tabItems: globaTabItems,
    activeTabIndex: 0
  },
  getters: {
    loginState: state => {
      const sloginState = sessionStorage.getItem("loginState");
      if (sloginState) {
        state.loginUser.state = Number(sloginState);
      }
      return state.loginUser.state;
    },
    loginToken: state => {
      const sloginToken = sessionStorage.getItem("loginToken");
      if (sloginToken) {
        state.loginUser.token = sloginToken;
      }
      return state.loginUser.token;
    },
    loginUser: state => {
      if (!globalLoginUser.user) {
        const sloginUser = sessionStorage.getItem("loginUser");
        if (sloginUser) {
          globalLoginUser.user = JSON.parse(sloginUser) as User;
        }
      }
      return state.loginUser.user;
    }, 
    loginUserPermissions: state => {
      return state.loginUser.permissions;
    }
  },
  mutations: {
    setLoginState(state, loginState) {
      state.loginUser.state = loginState;
      sessionStorage.setItem("loginState", loginState);
    },
    setLoginToken(state, token) {
      state.loginUser.token = token;
      sessionStorage.setItem("loginToken", token);
    },
    setLoginUser(state, user) {
      state.loginUser.user = user;
      sessionStorage.setItem("loginUser", JSON.stringify(user));
    },
    setLoginUserPermissions(state, permissions) {
      state.loginUser.permissions = permissions;
    }
  },
  actions: {
    changeLoginState(context, loginState) {
      context.commit("setLoginState", loginState);
    },
    changeLoginToken(context, token) {
      context.commit("setLoginToken", token);
    },
    changeLoginUser(context, user) {
      context.commit("setLoginUser", user);
    },
    changeLoginUserPermissions(context, permissions) {
      context.commit("setLoginUserPermissions", permissions);
    }
  }
});
